export const validationUtils = {
  /**
   * Validate email format
   * @param email - Email to validate
   * @returns boolean - True if email is valid
   */
  isValidEmail(email: string): boolean {
    // Basic email regex pattern
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
    // Check if email matches the pattern
    if (!emailRegex.test(email)) {
      return false;
    }
    
    // Additional checks for common invalid patterns
    const invalidPatterns = [
      /\.{2,}/, // Multiple consecutive dots
      /^\./, // Starts with dot
      /\.$/, // Ends with dot
      /@\./, // @ followed by dot
      /\.@/, // Dot followed by @
      /^[^a-zA-Z0-9]/, // Starts with non-alphanumeric
      /[^a-zA-Z0-9]$/, // Ends with non-alphanumeric
      /[^a-zA-Z0-9._%+-@]/, // Contains invalid characters
    ];
    
    for (const pattern of invalidPatterns) {
      if (pattern.test(email)) {
        return false;
      }
    }
    
    // Check domain has valid TLD (at least 2 characters)
    const domain = email.split('@')[1];
    if (!domain) {
      return false;
    }
    
    const tld = domain.split('.').pop();
    if (!tld || tld.length < 2) {
      return false;
    }
    
    return true;
  },

  /**
   * Validate password strength
   * @param password - Password to validate
   * @returns object - Validation result with isValid and message
   */
  validatePassword(password: string): { isValid: boolean; message?: string } {
    if (password.length < 6) {
      return { isValid: false, message: 'Mật khẩu phải có ít nhất 6 ký tự' };
    }
    
    if (password.length > 128) {
      return { isValid: false, message: 'Mật khẩu không được quá 128 ký tự' };
    }
    
    return { isValid: true };
  },

  /**
   * Get email validation error message
   * @param email - Email to validate
   * @returns string - Error message or empty string if valid
   */
  getEmailError(email: string): string {
    if (!email) {
      return 'Email không được để trống';
    }
    
    if (!this.isValidEmail(email)) {
      return 'Email không hợp lệ. Vui lòng nhập email đúng định dạng (ví dụ: example@domain.com)';
    }
    
    return '';
  },

  /**
   * Get password validation error message
   * @param password - Password to validate
   * @returns string - Error message or empty string if valid
   */
  getPasswordError(password: string): string {
    if (!password) {
      return 'Mật khẩu không được để trống';
    }
    
    const validation = this.validatePassword(password);
    return validation.message || '';
  }
}; 